(function () {
    'use strict';

    function SmsTextEditorComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.equivalentList = [];
        $ctrl.onEquivalentClick = onEquivalentClick;
        $ctrl.id = "field_sms_editor_" + Math.floor(Math.random() * 10000) + 1;


        loadAll();
        loadPage();

        function loadAll() {
            init();
        }

        function loadPage(page) {
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

        }

        function init() {
            initEquivalents();
        }

        function onEquivalentClick(item) {


            var textarea = document.getElementById($ctrl.id);
            var start_position = textarea.selectionStart;
            var end_position = textarea.selectionEnd;


            if (item) {
                var temp = textarea.value;
                textarea.value = temp.substring(0, start_position) + item.action + temp.substring(end_position, textarea.value.length);
            }
            $ctrl.smsText = textarea.value
        }

        function initEquivalents() {
            $ctrl.equivalentList = [];

            var eq = {};
            eq.title = 'نام کوچک مشتری';
            eq.action = '$CustomerFirstName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام خانوادگی مشتری';
            eq.action = '$CustomerLastName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام کامل مشتری';
            eq.action = '$CustomerName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'موبایل مشتری';
            eq.action = '$CustomerPhoneNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'شماره رزرو';
            eq.action = '$ReserveNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تاریخ رزرو';
            eq.action = '$ReserveDate$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان رزرو';
            eq.action = '$ReserveTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان پایان رزرو';
            eq.action = '$ReserveEndTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'عنوان کسب و کار';
            eq.action = '$CompanyTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تلفن کسب و کار';
            eq.action = '$CompanyPhoneNumber$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'آدرس کسب و کار';
            eq.action = '$CompanyAddress$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام خدمت';
            eq.action = '$ServiceTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'نام پرسنل';
            eq.action = '$ServantName$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'تاریخ مهلت پرداخت';
            eq.action = '$ConfirmationDeadlineDate$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'زمان مهلت پرداخت';
            eq.action = '$ConfirmationDeadlineTime$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'قیمت نهایی(str)';
            eq.action = '$FinalPriceStr$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'قیمت نهایی';
            eq.action = '$FinalPrice$';
            $ctrl.equivalentList.push(eq);
            //.................................
            eq = {};
            eq.title = 'خدمات افزوده';
            eq.action = '$ServiceItemOptionTitle$';
            $ctrl.equivalentList.push(eq);
            //.................................

        }

    }

    var SmsTextEditorComponent = {

        templateUrl: 'app/components/partial-forms/sms-text-editor/partial-form.sms-text-editor.html',
        controller: SmsTextEditorComponentController,
        bindings:
            {
                smsText: '=',
                label: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfSmsTextEditor', SmsTextEditorComponent)

    SmsTextEditorComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

